import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { SearchCustomerViewModel } from "src/Crm/searchCustomer/searchCustomer-viewModel";
import { SendToLocalNotificationMessage } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import  { CustomerTurnOverView } from "./customerTurnOver-view"
import { CurrentCredentials } from "src/server/currentCredentials";
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";
export class CustomerTurnOverViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'گردش حساب مشتری';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.customerId = '';
        this.lineItems = ObservableArray.create<lineItem>();
        this.customerSelector = new SearchCustomerViewModel(this);
        this.customerSelector.onSelectionChanged = x=>{
            this.customerName = x.name,
            this.customerCode = x.code;
            this.customerId = x.id;
        };
        this.from =  CurrentCredentials.fiscalPeriodStart.clone().add(2,"day");
        this.until = moment.utc();
        this.shallChooseMainDistrict = false;
    }

    GetDefaultView(): View <ViewModel> {
        return new CustomerTurnOverView();
    }
    public getTypeId(): string {
        return "VM-2FB38928-D99B-4D0C-840A-D9B7DE48FC0E"
    }
    public set mainDistrictSelectorViewModel(v: DistrictSelectorViewModel) { this._mainDistrictSelectorViewModel = v; } public get mainDistrictSelectorViewModel(): DistrictSelectorViewModel { return this._mainDistrictSelectorViewModel;} private _mainDistrictSelectorViewModel: DistrictSelectorViewModel;
    public set shallChooseMainDistrict(v: boolean) { this._shallChooseMainDistrict = v; } public get shallChooseMainDistrict(): boolean { return this._shallChooseMainDistrict;} private _shallChooseMainDistrict: boolean;
    
    public set from(v: moment.Moment) { 
        let v2 = v.clone().local().hour(0).minute(0).second(0).millisecond(0)
        this._from = v2; 
    } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { 
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._until = v2; 
    } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    
    
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    public set remaining(v: string) { this._remaining = v; } public get remaining(): string { return this._remaining;} private _remaining: string;
    public set remainingAmount(v: number) { this._remainingAmount = v; } public get remainingAmount(): number { return this._remainingAmount;} private _remainingAmount: number;
    public set canPrint(v: boolean) { this._canPrint = v; } public get canPrint(): boolean { return this._canPrint;} private _canPrint: boolean;
    public set credit(v: number) { this._credit = v; } public get credit(): number { return this._credit;} private _credit: number;
    async callService(){
        let result = await ServerConnection.callServer('Complex/FinancialServices/GetCustomerAccountTurnOver',{
            From:this.from,
            Until:this.until,
            CustomerId:this.customerId
        });
        return result;
    }
    async calculate(){
        if(this.customerId==''){
            this.messageBoxConfirmWarning("مشتری انتخاب نشده است.",'خطا');
        }else{
            try {
                this.isLoading = true;
                let result = await this.callService();
                this.credit = result.Credit;
                let turnOvers : lineItem[] = result.TurnOvers.map(x=>{
                    let r = new lineItem(this);
                    r.date = moment.utc(x.Time);
                    r.currencyName = x.CurrencyName;
                    r.reason = x.Description;
                    r.transactionCode = x.TransactionCode;
                    if(x.Amount>0){
                        r.debt = `${x.Amount}`;
                        r.credit = '0';
                        r.debtAmount = x.Amount;
                        r.creditAmount = 0;
                    }else{
                        r.debt ='0';
                        r.credit = `(${-x.Amount})`;
                        r.debtAmount = 0;
                        r.creditAmount = -x.Amount;
                    }
                    if(x.Total<0){
                        r.remaining = `(${-x.Total})`;
                        r.remainingAmount = -x.Total;
                    }else{
                        r.remaining = `${x.Total}`;
                        r.remainingAmount = x.Total;
                    }
                    return r;
                });
                var initial = new lineItem(this);
                initial.reason = 'مانده';
                initial.date = this.from;
                initial.currencyName = 'ریال'
                if(result.InitialBalance>0){
                    initial.debt = `${result.InitialBalance}`;
                    initial.credit = '0';
                    initial.debtAmount = result.InitialBalance;
                    initial.creditAmount = 0;
                }else{
                    initial.debt ='0';
                    initial.debtAmount = 0;
                    initial.credit = `(${-result.InitialBalance})`;
                    initial.creditAmount = -result.InitialBalance;
                }
                if(result.InitialBalance<0){
                    initial.remaining = `(${-result.InitialBalance})`;
                    initial.remainingAmount = -result.InitialBalance;
                }else{
                    initial.remaining = `${result.InitialBalance}`;
                    initial.remainingAmount = result.InitialBalance;
                }

                turnOvers.unshift(initial);
                if(result.FinalBalance<0){
                    this.remaining = `(${-result.FinalBalance})`;
                    this.remainingAmount = -result.FinalBalance;
                }else{
                    this.remaining = `${result.FinalBalance}`;
                    this.remainingAmount = result.FinalBalance;
                }
                turnOvers.forEach((x,i)=>{
                    x.index = i+1;
                })
                this.lineItems.update(...turnOvers);
                this.canPrint = true;
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            } finally {
                this.isLoading = false;
            }
        }
    }

    async print() {
        new PrintTurnOverAction().Print(this);
    }
}

export class lineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;
    public set debt(v: string) { this._debt = v; } public get debt(): string { return this._debt;} private _debt: string;
    public set debtAmount(v: number) { this._debtAmount = v; } public get debtAmount(): number { return this._debtAmount;} private _debtAmount: number;
    public set credit(v: string) { this._credit = v; } public get credit(): string { return this._credit;} private _credit: string;
    public set creditAmount(v: number) { this._creditAmount = v; } public get creditAmount(): number { return this._creditAmount;} private _creditAmount: number;
    public set remaining(v: string) { this._remaining = v; } public get remaining(): string { return this._remaining;} private _remaining: string;
    public set remainingAmount(v: number) { this._remainingAmount = v; } public get remainingAmount(): number { return this._remainingAmount;} private _remainingAmount: number;
    public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode;} private _transactionCode: string;
    public set currencyName(v: string) { this._currencyName = v; } public get currencyName(): string { return this._currencyName;} private _currencyName: string;
    
}

export class PrintTurnOverAction{
    public async Print(parent:CustomerTurnOverViewModel):Promise<void>{
        var message = new SendToLocalNotificationMessage("requestPrint",{
            Form:"AccountTurnOver",
            Data:{
                CopyCount:1,
                CustomerName:parent.customerName,
                CustomerCode:parent.customerCode,
                FinalTurnOver:parent.remainingAmount,
                From:parent.from,
                Until:parent.until,
                Items:parent.lineItems.map((x,i)=>{
                    return {
                        Index:i+1,
                        Time:x.date,
                        TimeString:x.date.toString,
                        Description:x.reason,
                        Debt:x.debtAmount,
                        Credit:x.creditAmount,
                        Remaining:x.remainingAmount
                    };
                })
            }
        });
        return parent.handleMessage(message);
    }
}

export class CustomerTurnOverForDistrictSaleViewModel extends CustomerTurnOverViewModel{

    public override getTitle(): string {
        return 'گردش حساب مشتری - شعب';
    }

    public override async  callService(): Promise<any> {
        let result = await ServerConnection.callServer('Complex/FinancialServices/GetCustomerAccountTurnOverForDistrictSale',{
            From:this.from,
            Until:this.until,
            CustomerId:this.customerId
        });
        return result; 
    }
}

export class DistrictTurnOverForDistrictSaleViewModel extends CustomerTurnOverViewModel{

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        let districtSelector = new DistrictSelectorViewModel(this,false); 
        this.customerSelector = <any>districtSelector;
        districtSelector.onSelectionChanged = x=>{
            this.customerName = x.title,
            this.customerCode = "";
            this.customerId = x.id;
        };
        
    }
    public override getTitle(): string {
        return 'گردش حساب شعب - شعب';
    }

    public override async  callService(): Promise<any> {
        let result = await ServerConnection.callServer('Complex/FinancialServices/GetDistrictAccountTurnOverForDistrictSale',{
            From:this.from,
            Until:this.until,
            CustomerId:this.customerId
        });
        return result; 
    }
}


export class AdminCustomerTurnOverForDistrictSaleViewModel extends CustomerTurnOverViewModel{

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.mainDistrictSelectorViewModel = new DistrictSelectorViewModel(this,false);
        this.shallChooseMainDistrict = true;
    }
    public override getTitle(): string {
        return 'گردش حساب مشتری - شعب - مدیریت';
    }

    public override async  callService(): Promise<any> {
        let result = await ServerConnection.callServer('Complex/FinancialServices/GetCustomerAccountTurnOverForDistrictSale',{
            From:this.from,
            Until:this.until,
            CustomerId:this.customerId,
            MainDistrictId : this.mainDistrictSelectorViewModel.selectedItem?.id
        });
        return result; 
    }
}

export class AdminDistrictTurnOverForDistrictSaleViewModel extends CustomerTurnOverViewModel{

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        let districtSelector = new DistrictSelectorViewModel(this,false); 
        this.mainDistrictSelectorViewModel = new DistrictSelectorViewModel(this,false);
        this.shallChooseMainDistrict = true;
        
        this.customerSelector = <any>districtSelector;
        districtSelector.onSelectionChanged = x=>{
            this.customerName = x.title,
            this.customerCode = "";
            this.customerId = x.id;
        };
        
    }
    public override getTitle(): string {
        return 'گردش حساب شعب - شعب - مدیریت';
    }

    public override async  callService(): Promise<any> {
        let result = await ServerConnection.callServer('Complex/FinancialServices/GetDistrictAccountTurnOverForDistrictSale',{
            From:this.from,
            Until:this.until,
            CustomerId:this.customerId,
            MainDistrictId : this.mainDistrictSelectorViewModel.selectedItem?.id
        });
        return result; 
    }
}